

export const FETCH_EMPLOYEES_REQUEST = "FETCH_EMPLOYEES_REQUEST"
export const FETCH_EMPLOYEES_SUCCESS = "FETCH_EMPLOYEES_SUCCESS"
export const FETCH_EMPLOYEES_FAILED =  "FETCH_EMPLOYEES_FAILED"


export const DELETE_EMPLOYEE_REQUEST =  "DELETE_EMPLOYEE_REQUEST"
export const DELETE_EMPLOYEE_SUCCESS =  "DELETE_EMPLOYEE_SUCCESS"
export const DELETE_EMPLOYEE_FAILED =  "DELETE_EMPLOYEE_FAILED"